import { useEffect } from 'react';
import { initAnalytics } from '@/analytics/posthog';
import { useTrackingConsent } from '@/analytics/consent';

export function PostHogAnalytics() {
  const consent = useTrackingConsent();

  useEffect(() => {
    if (consent === 'granted') initAnalytics();
  }, [consent]);

  return null;
}
